import { makeStyles } from 'tss-react/mui';
import {Black} from 'wobi-web-common/dist/Colors';
import {agentDeveloperUtils} from 'wobi-web-common/dist/components/utils/helpers';

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of CallExpression.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of NumericLiteral.
// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of NumericLiteral.
const useStyles = makeStyles()(theme => ({
  addressSection: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  autoFillButton: {
    fontSize: '0.75rem',
    left: 140,
    lineHeight: 1,
    position: 'absolute',
    top: 12,
    width: 'auto',
  },
  autoInfoDetails: {
    '& .borderBottom': {
      '&:first-of-type': {
        paddingTop: 0,
      },
      '&:last-child': {
        borderBottom: 'none',
      },
      borderBottom: `2px dotted ${agentDeveloperUtils.getSecondaryColor(100)}`,
    },
    '& .borderBottom2': {
      borderBottom: `2px dotted ${agentDeveloperUtils.getSecondaryColor(100)}`,
    },
    '& .details': {
      '& .brand-logo': {
        borderRight: '1px solid #ECF5F8',
        marginRight: 10,
        paddingRight: 10,
        width: 50,
      },
      '& > div': {
        '& > span': {
          fontWeight: 'normal',
          width: 90,
        },
        alignItems: 'center',
        color: agentDeveloperUtils.getSecondaryColor(300),
        display: 'flex',
        fontSize: 16,
        fontWeight: 600,

        height: 60,
      },
      marginBottom: 30,
    },

    '& .title-row': {
      color: agentDeveloperUtils.getConvertedColor(Black[300]),
      fontSize: 21,
      fontWeight: 500,
    },
  },
buildingNumber: {
  '& input': {
    color: 'black',
    fontSize: 13,
  },
},
  color: {
    color: agentDeveloperUtils.getConvertedColor(Black[300]),
  },
  closeSidebarButton: {
    '& .MuiIcon-root': {
      fontSize: '20px',
    },
    marginLeft: 'auto',
    minWidth: 'auto',
    padding: '8px',
  },
  defaultButton: {
    marginLeft: 20,
  },
  expandButton: {
    '&:hover': {
      backgroundColor: agentDeveloperUtils.getSecondaryColor(200),
    },
    backgroundColor: agentDeveloperUtils.getSecondaryColor(300),
    borderRadius: '20px',
    color: agentDeveloperUtils.getSecondaryColor(500),
    fontSize: '12px',
    margin: '10px auto',
    padding: '6px 16px',
    width: '100%',
  },
  flex: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  flexRow: {
    '& > *': {
      marginRight: 12,
    },
    display: 'flex',
  },

  fontSize: {
    fontSize: 13,
  },
  fullWidth: {
    '&.no-margin': {
      marginTop: 0,
    },
    width: '100%',
  },
  hide: {
    display: 'none',
  },
  iContinuity: {
    alignItems: 'center',
    height: 60,
    marginBottom: 10,
  },
  iTypeSelect: {
    '&.mrgr0': {marginLeft: 'unset'},
    marginTop: 6,
  },

  lineHeight: {
    lineHeight: 1.5,
  },
  loaderContainer: {
    '&.hide': {
      display: 'none',
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    width: '100%',
  },
  localHeader: {
    '& img': {
      display: 'block',
    },
    backgroundColor: 'rgb(255, 255, 255)',
    padding: '10px 0',
    position: 'fixed',
    width: '100%',

    zIndex: 2,
  },

  mainContainer: {
    '& label.MuiFormLabel-root': {
      fontSize: 13,
      lineHeight: 1,
      maxWidth: '75%',
      top: -4,
    },
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  offerColumn: {
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '400px',
    padding: '0 8px 16px',
  },

  offerColumnHeaderSticky: {
    '& h3': {
      color: agentDeveloperUtils.getSecondaryColor(500),
      fontSize: '24px',
      fontWeight: 'bold',
      margin: 0,
    },
    backgroundColor: '#f8f9fa',
    borderBottom: `2px solid ${agentDeveloperUtils.getPrimaryColor(200)}`,
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    marginBottom: '12px',
    padding: '16px 10px 12px',
    position: 'sticky',
    textAlign: 'center',
    top: '60px',
    zIndex: 1,
  },

  offersWrapper: {
    minHeight: '400px',
    position: 'relative',
  },

  purchaseLoadingOverlay: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 1300,
  },

  sidebarBody: {
    flex: 1,
    overflowY: 'auto',
    padding: '20px',
  },

  sidebarBodyDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },

  sidebarLoadingBanner: {
    alignItems: 'center',
    backgroundColor: agentDeveloperUtils.getPrimaryColor(100),
    borderBottom: `1px solid ${agentDeveloperUtils.getPrimaryColor(300)}`,
    color: agentDeveloperUtils.getPrimaryColor(500),
    display: 'flex',
    fontSize: '14px',
    fontWeight: 500,
    gap: '10px',
    justifyContent: 'center',
    padding: '12px 16px',
  },

  sidebarContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  sidebarHeader: {
    '& h3': {
      fontWeight: 'bold',
      margin: 0,
    },
    alignItems: 'center',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  sidebarToolbar: {
    '& > div': {
      flex: '0 0 auto',
      minWidth: '180px',
    },
    '& button': {
      flex: '0 0 auto',
      whiteSpace: 'nowrap',
    },
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '30px',
    padding: '16px',
  },
  subtitle: {
    color: agentDeveloperUtils.getConvertedColor(Black[220]),
    flexGrow: 1,
    fontSize: 14,
  },
  title: {
    color: agentDeveloperUtils.getConvertedColor(Black[300]),
    fontSize: 21,
    fontWeight: 600,
    margin: 0,
    marginBottom: 10,
  },
  toggleButton: {
    '& .MuiIcon-root': {
      fontSize: '18px',
    },
    alignItems: 'center',
    display: 'flex',
    gap: '8px',
    marginLeft: '20px',
  },
  tooltip: {
    '& div': {
      maxWidth: 'unset',
    },
  },
  wrapperDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  yesNoSelectWrapper: {
    justifyContent: 'flex-start',
  },
}));

export default useStyles;
